import React from "react";
import { Crown } from "@phosphor-icons/react";

export default function ProBadge({ size = 12, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 bg-gradient-to-r from-[#FFCC00] to-[#FF9500] text-black text-[10px] font-bold uppercase tracking-widest ${className}`}>
      <Crown weight="fill" size={size} />
      <span>Pro</span>
    </span>
  );
}
